(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
	class UspBar extends HTMLElement {
		constructor() {
			super();
			this.items = Array.from(this.querySelectorAll('[data-usp-item]'));
			this.current = Math.max(
				this.items.findIndex((item) => item.classList.contains('is-active')),
				0,
			);
			this.speed = Number(this.dataset.autoplaySpeed) || 5000;

			this.querySelector('.bs-announcement-bar__arrow--prev')?.addEventListener('click', () => this.show(this.current - 1));
			this.querySelector('.bs-announcement-bar__arrow--next')?.addEventListener('click', () => this.show(this.current + 1));

			this.addEventListener('shopify:block:select', (event) => {
				const index = this.items.indexOf(event.target);
				if (index > -1) this.show(index);
			});

			this.play();
		}

		show(index) {
			const total = this.items.length;
			this.current = (index + total) % total;
			this.items.forEach((item, i) => item.classList.toggle('is-active', i === this.current));
			this.play();
		}

		play() {
			if (this.items.length < 2) return;
			clearInterval(this.autoplay);
			this.autoplay = setInterval(() => this.show(this.current + 1), this.speed);
		}

		disconnectedCallback() {
			clearInterval(this.autoplay);
		}
	}

	customElements.define('usp-bar', UspBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bs-action-bar"] && !Shopify.designMode) return;
  try {
    
	(function () {
		const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

		function rememberDismissal() {
			try {
				if (window.Shopify && Shopify.designMode) return;
				sessionStorage.setItem('bs-action-bar-dismissed', '1');
			} catch (error) {}
		}

		function closeActionBar(actionBar) {
			const section = actionBar.closest('.shopify-section') || actionBar;
			if (section.classList.contains('is-closing') || section.classList.contains('is-closed')) return;
			rememberDismissal();

			let finished = false;
			const finish = function () {
				if (finished) return;
				finished = true;
				section.classList.remove('is-closing');
				section.classList.add('is-closed');
				section.style.height = '0px';
				section.style.display = 'none';
				section.setAttribute('aria-hidden', 'true');
				window.dispatchEvent(new Event('resize'));
			};

			const startHeight = section.getBoundingClientRect().height;
			if (reduceMotionQuery.matches || startHeight === 0) {
				finish();
				return;
			}

			section.style.height = startHeight + 'px';
			section.classList.add('is-closing');

			window.requestAnimationFrame(function () {
				window.requestAnimationFrame(function () {
					section.style.height = '0px';
				});
			});

			const onEnd = function (event) {
				if (event.target !== section || event.propertyName !== 'height') return;
				section.removeEventListener('transitionend', onEnd);
				finish();
			};

			section.addEventListener('transitionend', onEnd);
			window.setTimeout(finish, 500);
		}

		function bindActionBar(root) {
			const scope = root && root.querySelector ? root : document;
			const actionBar = scope.querySelector('.bs-action-bar');
			const actionBarButton = actionBar ? actionBar.querySelector('.bs-action-bar__button') : null;
			if (!actionBar || !actionBarButton || actionBarButton.dataset.closeBound === 'true') return;

			actionBarButton.dataset.closeBound = 'true';
			actionBarButton.addEventListener('click', function (event) {
				event.preventDefault();
				event.stopPropagation();
				closeActionBar(actionBar);
			});
		}

		function init() {
			bindActionBar(document);
		}

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', init);
		} else {
			init();
		}

		document.addEventListener('shopify:section:load', function (event) {
			bindActionBar(event.target);
		});
	})();

  } catch(e) { console.error(e); }
})();
})();
